import { render } from "./TeamInvite.vue?vue&type=template&id=70bd56f8"
import script from "./TeamInvite.vue?vue&type=script&lang=js"
export * from "./TeamInvite.vue?vue&type=script&lang=js"
script.render = render

export default script